import { ReduxActionTypes } from "legacy/constants/ReduxActionConstants";

import type { Flag } from "./models/Flags";

// Define an action creator for updating a flag
export function updateFlag(flagName: Flag, value: any) {
  return {
    type: ReduxActionTypes.UPDATE_FEATURE_FLAG,
    payload: { flagName, value },
  };
}
